exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: bold;\n  margin-bottom: 20px;\n  margin-left: -10px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.order {\n  font-size: 12px;\n}\n\n.order .item {\n  margin-bottom: 10px;\n}\n\n.row {\n  border-bottom: #79a3db 1px solid;\n  margin-bottom: 5px;\n}\n\n.error {\n  background-color: darkred;\n  color: white;\n  padding: 5px;\n}\n\n.success {\n  background-color: darkgreen;\n  color: white;\n  padding: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/indexeddbpage/indexeddbpage.component.scss
// module id = ../../../../../src/app/pages/indexeddbpage/indexeddbpage.component.scss
// module chunks = main